import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
  lines = [
    new Line({ color: 0x21D4FE }),
    new Line({ color: 0x21D4FE }),
    new Line({ color: 0xB06EFE }),
    new Line({ color: 0xB06EFE }),
  ]
  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
  }
  
  clearAll = () => this.lines.forEach(l => l.clear());
  draw(intersecCoord: Coord, chordsCoords: Coord[][]) {
    const chordA = chordsCoords[0];
    const chordB = chordsCoords[1];
    this.lines[0].draw(chordA[0], chordA[2]);
    this.lines[1].draw(chordA[1], intersecCoord);
    this.lines[2].draw(chordB[0], chordB[2]);
    this.lines[3].draw(chordB[1], intersecCoord);
  }
}